import { useLocation, Link } from "react-router-dom";

const SEARCH_PAGES = [
  { title: "Home", path: "/" },
  { title: "Events", path: "/state-schedule" },
  { title: "How to Become a Member", path: "/how-to-become-member" },
  { title: "Membership Model", path: "/membership-model" },
  { title: "Membership Count", path: "/membership-count" },
  { title: "State Mapping", path: "/state-mapping" },
  { title: "Voter List", path: "/voter-list" },
  { title: "On Hold List", path: "/on-hold-list" },
  { title: "Reject List", path: "/reject-list" },
  { title: "Voter Search", path: "/voter-search" },
  { title: "View Nomination", path: "/view-nomination" },
  { title: "Performers List", path: "/performers-list" },
  { title: "Election Result", path: "/get-result" },
  { title: "RO Details", path: "/ro-details" },
  { title: "RO Schedule", path: "/ro-schedule" },
  { title: "Reserved Districts", path: "/reserved-districts" },
];

export default function SearchResults() {
  const { search } = useLocation();
  const query = new URLSearchParams(search).get("q")?.toLowerCase() || "";

  const results = SEARCH_PAGES.filter(p =>
    p.title.toLowerCase().includes(query)
  );

  return (
    <div style={{ padding: 30 }}>
      <h2>
  Search results for <span>&quot;{query}&quot;</span>
</h2>
      {results.length === 0 && <p>No results found.</p>}

      <ul>
        {results.map(r => (
          <li key={r.path}>
            <Link to={r.path}>{r.title}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
